export default function simpleDecodeEntities(text) {
	return typeof text === 'string' ? text.replace(/&amp;/g, '&')
		.replace(/&lt;/g, '<')
		.replace(/&gt;/g, '>')
		.replace(/&quot;/g, '"') : text;
}


// WEBPACK FOOTER //
// ./src/utils/entities.js